/**
 * AdminRequestAccess Messages
 *
 * This contains all the text for the AdminRequestAccess component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.admin.requestAccess';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Request Access',
  },
  tabToDo: {
    id: `${scope}.tabToDo`,
    defaultMessage: 'To do',
  },
  tabComplete: {
    id: `${scope}.tabComplete`,
    defaultMessage: 'Complete',
  },
  noRequests: {
    id: `${scope}.noRequests`,
    defaultMessage: 'No requests',
  },
  noCompletedRequests: {
    id: `${scope}.noCompletedRequests`,
    defaultMessage: 'No completed requests',
  },
});
